/* eslint-disable max-len */
export const MgmMainPageResources = {
  goodieAdvantages: {
    title: "<b>Zalety</b> goodie cashback",
  },

  cta: {
    receiverBonusAmount: "Bonus {receiverBonus} zł czeka na Ciebie!",
    description: "Aby skorzystać z promocji, <b>zweryfikuj numer telefonu</b>",
    button: "Zweryfikuj",

    missingTrxTitle: "Twój bonus czeka na Ciebie!",
    missingTrxDescription: "Zrób pierwsze zakupy z goodie cashback, żeby otrzymać bonus",
    missingTrxButton: "Zacznij zakupy",
  },

  dashboard: {
    title: "Polecaj i <b>zarabiaj</b>",
    bonusDescription: "{senderBonus} zł dla Ciebie, {receiverBonus} zł dla znajomego",

    inputTitle: "<b>Udostępnij</b> kod znajomemu",

    referralLabel: "Twój link polecający",
    referralBtnShare: "Udostępnij",
    referralBtnCopy: "Kopiuj link",
    referralCopied: "Skopiowano",

    shareCodeTitle: "goodie cashback - nawet 25% zwrotu za zakupy online!",
    shareCodeMessage: "Cześć! 😄 Polecam Ci aplikację goodie, dzięki której możesz odzyskiwać nawet 25% wydatków na zakupy online w ponad 800 sklepach. A jeśli skorzystasz z mojego linka otrzymasz bonus - {receiverBonus} zł cashback. 🤩 Kliknij w link poniżej i zarejestruj się, wybierz sklep, w którym chcesz zrobić zakup, przejdź do niego przez goodie, zrób zakupy jak zawsze i cashback będzie Twój. Sprawdź - aplikacja goodie jest bezpieczna i całkowicie darmowa. ✅",

    codeLabel: "Twój kod polecający",
    codeBtn: "Zmień kod",
  },

  changeCode: {
    title: "Zmień kod",
    description: "Stwórz własny kod polecający. Bonusy ze wszystkich Twoich poleceń naliczą się na Twoim koncie.",
    descriptionWarning: "<b>Uwaga!</b> Jeżeli zmienisz kod (możesz to zrobić maksymalnie 3 razy), Twój poprzedni kod straci ważność, a Twoi znajomi już nie będą mogli z niego skorzystać.",
    inputPlaceholder: "Wpisz kod",
    btnUpdate: "Zapisz",
    btnBack: "Anuluj",

    errorGeneric: "Twój kod powinien zawierać od 3 do 12 znaków, wyłącznie litery i cyfry. Wybierz kod spełniający te wymagania.",
  },

};
